import { getXencioTraceId } from './utils';

/**
 * 设置全局 fetch 拦截器
 * 用于统一添加 xencio-trace-id 请求头
 */
export function setupFetchInterceptor() {
  const originalFetch = window.fetch;

  window.fetch = async (input: RequestInfo | URL, init?: RequestInit) => {
    // 获取 traceId
    const traceId = getXencioTraceId();
    
    // 复制 init 对象
    const newInit = init ? { ...init } : {};
    
    // 处理 headers
    if (!newInit.headers) {
      newInit.headers = { 'xencio-trace-id': traceId };
    } else if (newInit.headers instanceof Headers) {
      // 复制 Headers 对象以避免副作用
      const newHeaders = new Headers(newInit.headers);
      newHeaders.append('xencio-trace-id', traceId);
      newInit.headers = newHeaders;
    } else if (Array.isArray(newInit.headers)) {
      // 复制数组
      const newHeaders = [...newInit.headers];
      newHeaders.push(['xencio-trace-id', traceId]);
      newInit.headers = newHeaders;
    } else {
      // 普通对象
      newInit.headers = {
        ...newInit.headers,
        'xencio-trace-id': traceId
      };
    }
    
    return originalFetch(input, newInit);
  };
}
